import { Button, Grid } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import DialogApp from "../dialog-app/dialog-app.component";
import "./lodge-item.styles.scss";

const LodgeItem = ({ lodge, autoOpen }) => {
  const openEmail = () => {
    window.open(
      "mailto:email@example.com?subject=Subject&body=Body%20goes%20here"
    );
  };

  if (lodge === undefined) {
    return <div></div>;
  } else {
    // console.log("entro!!");
    // console.log(lodge);
    return (
      <div>
        <div>
          <Grid container spacing={3}>
            {/* City/State */}
            <Grid item xs={10} sm={3}>
              <Box gridColumn="span 1" sx={{ paddingBottom: 2 }}>
                <span>
                  <b>City/State</b>
                </span>
              </Box>

              <Box gridColumn="span 1">
                <span>
                  {lodge.CITY}, {lodge.STATE_CODE} {lodge.COUNTRY}
                </span>
              </Box>
            </Grid>
            {/* Lodge */}
            <Grid item xs={10} sm={3}>
              <Box
                gridColumn="span 1"
                sx={{
                  paddingBottom: 2,
                }}
              >
                <span>
                  <b>Lodge</b>
                </span>
              </Box>

              <Box gridColumn="span 1">
                <span>{lodge.LODGE_NAME}</span>
              </Box>
              <Box gridColumn="span 1">
                <span>
                  {lodge.DISTRICT_ID}-{lodge.LODGE_ID}
                </span>
              </Box>
            </Grid>

            {/* Contact Officer */}
            <Grid item xs={10} sm={3}>
              <Box
                gridColumn="span 1"
                sx={{
                  paddingBottom: 2,
                }}
              >
                <span>
                  <b>Officers</b>
                </span>
              </Box>

              {(() => {
                if (lodge.EMAIL_SECRETARY && lodge.EMAIL_VIC) {
                  return (
                    <Box gridColumn="span 1">
                      <DialogApp
                        email={lodge.EMAIL_SECRETARY + "," + lodge.EMAIL_VIC}
                        autoOpen={autoOpen}
                        lodgeName={lodge.LODGE_NAME}
                        districtId={lodge.DISTRICT_ID}
                        lodgeId={lodge.LODGE_ID}
                      />
                    </Box>
                  );
                } else if (lodge.EMAIL_VIC) {
                  return (
                    <Box gridColumn="span 1">
                      <DialogApp
                        email={lodge.EMAIL_VIC}
                        autoOpen={autoOpen}
                        lodgeName={lodge.LODGE_NAME}
                        districtId={lodge.DISTRICT_ID}
                        lodgeId={lodge.LODGE_ID}
                      />
                    </Box>
                  );
                } else if (lodge.EMAIL_SECRETARY) {
                  return (
                    <Box gridColumn="span 1">
                      <DialogApp
                        email={lodge.EMAIL_SECRETARY}
                        autoOpen={autoOpen}
                        lodgeName={lodge.LODGE_NAME}
                        districtId={lodge.DISTRICT_ID}
                        lodgeId={lodge.LODGE_ID}
                      />
                    </Box>
                  );
                } else if (lodge.EMAIL_PRES) {
                  return (
                    <Box gridColumn="span 1">
                      <DialogApp
                        email={lodge.EMAIL_PRES}
                        autoOpen={autoOpen}
                        lodgeName={lodge.LODGE_NAME}
                        districtId={lodge.DISTRICT_ID}
                        lodgeId={lodge.LODGE_ID}
                      />
                    </Box>
                  );
                } else {
                  return (
                    <div>
                      No Secretary, No Vicepresident and no President{" "}
                      {lodge.EMAIL_PRES}{" "}
                    </div>
                  );
                }
              })()}
            </Grid>

            {/* Metting Location */}
            <Grid item xs={10} sm={3}>
              <Box gridColumn="span 1">
                <span>
                  <b>Meeting Location</b>
                </span>
              </Box>
              <Box gridColumn="span 1">
                <p>{lodge.LOCATION}</p>
                <p>{lodge.STREET}</p>
                <p>
                  {lodge.CITY}, {lodge.STATE_CODE}
                </p>
                <p>{lodge.SCHEDULE}</p>
              </Box>
            </Grid>
          </Grid>
        </div>
        <div>
          <Grid container spacing={3}>
            {/* Segunda Linea */}
            <Grid item xs={10} sm={3}>
              {/* Individual */}
              <Grid item xs={10}>
                <Box gridColumn="span 1">
                  <span>
                    <b>Annual Dues:</b>
                  </span>
                </Box>
                <Box gridColumn="span 1">
                  <span>Individual: {lodge.ANNUALDUES_INDIVIDUAL}</span>
                </Box>
              </Grid>
            </Grid>
            {/* Family */}
            <Grid item xs={10} sm={3}>
              <Grid item xs={10}>
                <Box gridColumn="span 1">
                  <p></p>
                </Box>
                <Box gridColumn="span 1">
                  <span>Family: {lodge.ANNUALDUES_FAMILY}</span>
                </Box>
              </Grid>
            </Grid>
            {/* Officer */}
            <Grid item xs={10} sm={3}>
              <span></span>
            </Grid>
            {/* Join */}
            <Grid item xs={10} sm={3}>
              {(() => {
                if (lodge.VOTE_REQUIRE_TO_JOIN === "N") {
                  return (
                    <Button
                      className="sonsBt"
                      variant="contained"
                      href={
                        "https://members.sofn.com/newMembers/signup/join?country=" +
                        lodge.COUNTRY +
                        "&district=" +
                        lodge.DISTRICT_ID +
                        "&lodge=" +
                        lodge.LODGE_ID +
                        "&lodgeName=" +
                        lodge.LODGE_NAME
                      }
                    >
                      Join this Lodge
                    </Button>
                  );
                } else {
                  return (
                    <Box
                      component="span"
                      sx={{ p: 1, border: "1px dashed grey" }}
                    >
                      <span>Contact Lodge Officers for details</span>
                    </Box>
                  );
                }
              })()}
            </Grid>
          </Grid>
        </div>
      </div>
    );
  }
};

export default LodgeItem;
